// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/search/v1/legacy_portal_service.proto (package spwn.search.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { LegacyPortalSearchAvailabilityStatus, LegacyPortalSearchEventType, LegacyPortalSearchResultEvent, LegacyPortalSearchResultGoods } from "./legacy_portal_common_pb";
/**
 * @generated from message spwn.search.v1.LegacyPortalSearchServiceSearchEventRequest
 */
export class LegacyPortalSearchServiceSearchEventRequest extends Message {
    constructor(data) {
        super();
        /**
         * 検索キーワード
         *
         * @generated from field: string keyword = 1;
         */
        this.keyword = "";
        /**
         * 公演日(以降)
         *
         * @generated from field: int64 opening_date_gte = 2;
         */
        this.openingDateGte = protoInt64.zero;
        /**
         * 公演日(以前)
         *
         * @generated from field: int64 opening_date_lte = 3;
         */
        this.openingDateLte = protoInt64.zero;
        /**
         * ジャンル(カテゴリ)
         *
         * @generated from field: repeated string genre = 4;
         */
        this.genre = [];
        /**
         * 種別
         *
         * @generated from field: repeated spwn.search.v1.LegacyPortalSearchEventType event_type = 5;
         */
        this.eventType = [];
        /**
         * 受付ステータス
         *
         * @generated from field: repeated spwn.search.v1.LegacyPortalSearchAvailabilityStatus availability_status = 6;
         */
        this.availabilityStatus = [];
        /**
         * 地域
         *
         * @generated from field: repeated string prefecture_codes = 7;
         */
        this.prefectureCodes = [];
        /**
         * hostingType
         *
         * @generated from field: string hosting_type = 8;
         */
        this.hostingType = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSearchServiceSearchEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSearchServiceSearchEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSearchServiceSearchEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalSearchServiceSearchEventRequest, a, b);
    }
}
LegacyPortalSearchServiceSearchEventRequest.runtime = proto3;
LegacyPortalSearchServiceSearchEventRequest.typeName = "spwn.search.v1.LegacyPortalSearchServiceSearchEventRequest";
LegacyPortalSearchServiceSearchEventRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "opening_date_gte", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "opening_date_lte", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "genre", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "event_type", kind: "enum", T: proto3.getEnumType(LegacyPortalSearchEventType), repeated: true },
    { no: 6, name: "availability_status", kind: "enum", T: proto3.getEnumType(LegacyPortalSearchAvailabilityStatus), repeated: true },
    { no: 7, name: "prefecture_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "hosting_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * 検索レスポンスのメッセージ
 *
 * @generated from message spwn.search.v1.LegacyPortalSearchServiceSearchEventResponse
 */
export class LegacyPortalSearchServiceSearchEventResponse extends Message {
    constructor(data) {
        super();
        /**
         * 検索結果のリスト
         *
         * @generated from field: repeated spwn.search.v1.LegacyPortalSearchResultEvent items = 1;
         */
        this.items = [];
        /**
         * 検索結果総件数
         *
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSearchServiceSearchEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSearchServiceSearchEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSearchServiceSearchEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalSearchServiceSearchEventResponse, a, b);
    }
}
LegacyPortalSearchServiceSearchEventResponse.runtime = proto3;
LegacyPortalSearchServiceSearchEventResponse.typeName = "spwn.search.v1.LegacyPortalSearchServiceSearchEventResponse";
LegacyPortalSearchServiceSearchEventResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: LegacyPortalSearchResultEvent, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * グッズ検索リクエスト
 *
 * @generated from message spwn.search.v1.LegacyPortalSearchServiceSearchGoodsRequest
 */
export class LegacyPortalSearchServiceSearchGoodsRequest extends Message {
    constructor(data) {
        super();
        /**
         * 検索キーワード
         *
         * @generated from field: string keyword = 1;
         */
        this.keyword = "";
        /**
         * hostingType
         *
         * @generated from field: string hosting_type = 2;
         */
        this.hostingType = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSearchServiceSearchGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSearchServiceSearchGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSearchServiceSearchGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalSearchServiceSearchGoodsRequest, a, b);
    }
}
LegacyPortalSearchServiceSearchGoodsRequest.runtime = proto3;
LegacyPortalSearchServiceSearchGoodsRequest.typeName = "spwn.search.v1.LegacyPortalSearchServiceSearchGoodsRequest";
LegacyPortalSearchServiceSearchGoodsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hosting_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.search.v1.LegacyPortalSearchServiceSearchGoodsResponse
 */
export class LegacyPortalSearchServiceSearchGoodsResponse extends Message {
    constructor(data) {
        super();
        /**
         * グッズ検索結果のリスト
         *
         * @generated from field: repeated spwn.search.v1.LegacyPortalSearchResultGoods items = 1;
         */
        this.items = [];
        /**
         * 検索結果総件数
         *
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSearchServiceSearchGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSearchServiceSearchGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSearchServiceSearchGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalSearchServiceSearchGoodsResponse, a, b);
    }
}
LegacyPortalSearchServiceSearchGoodsResponse.runtime = proto3;
LegacyPortalSearchServiceSearchGoodsResponse.typeName = "spwn.search.v1.LegacyPortalSearchServiceSearchGoodsResponse";
LegacyPortalSearchServiceSearchGoodsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: LegacyPortalSearchResultGoods, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 今後レスポンスの検索条件の項目を切り分ける実装を考慮して空の構造を定義
 * FANY向け検索にはレスポンスに会場を含める、など
 *
 * @generated from message spwn.search.v1.GetEventSearchConditionsRequest
 */
export class GetEventSearchConditionsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetEventSearchConditionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEventSearchConditionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEventSearchConditionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEventSearchConditionsRequest, a, b);
    }
}
GetEventSearchConditionsRequest.runtime = proto3;
GetEventSearchConditionsRequest.typeName = "spwn.search.v1.GetEventSearchConditionsRequest";
GetEventSearchConditionsRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.search.v1.GetEventSearchConditionsResponse
 */
export class GetEventSearchConditionsResponse extends Message {
    constructor(data) {
        super();
        /**
         * 検索カテゴリ
         *
         * @generated from field: repeated string genre = 1;
         */
        this.genre = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetEventSearchConditionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEventSearchConditionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEventSearchConditionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEventSearchConditionsResponse, a, b);
    }
}
GetEventSearchConditionsResponse.runtime = proto3;
GetEventSearchConditionsResponse.typeName = "spwn.search.v1.GetEventSearchConditionsResponse";
GetEventSearchConditionsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "genre", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map